// extracted by mini-css-extract-plugin
module.exports = {"container":"addCard_container__13a7A","heading":"addCard_heading__2GfOF","backArrow":"addCard_backArrow__1CkIn"};